// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import { ContextProvider } from './Context/Context';
// import { BrowserRouter } from 'react-router-dom';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <ContextProvider>
//         <App />
//       </ContextProvider>
//     </BrowserRouter>
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();





// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import { ContextProvider } from './Context/Context';
// import { HashRouter } from 'react-router-dom'; // ✅ Switched from BrowserRouter
// import { Helmet } from "react-helmet";

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <>
//     <Helmet>
//       <title>Matka Jantri | India’s Trusted Online Jantri Calculator & Record Maintainer for Matka Games</title>

//       <meta name="description"
//         content="Use Matka Jantri – India’s trusted online jantri calculator and matka record maintainer. APK for accurate and fast results. Easy to use on mobile and web." />

//       <meta name="keywords"
//         content="jantri, Matka Jantri, jantri calculator, matka games, jantri apk, record maintainer matka, satta matka jantri, jod calculator" />

//       <meta name="author" content="Matka Jantri Team (Miraj Sport's)" />

//       {/* <!-- Open Graph Meta for Social Sharing --? */}
//       <meta property="og:title" content="Matka Jantri | Online Jantri Calculator for Matka Games" />
//       <meta property="og:description"
//         content="Free jantri calculator and record maintainer APK for matka games. Try Matka Jantri online – fast, accurate and easy to use." />
//       <meta property="og:type" content="website" />
//       <meta property="og:url" content="https://pushpabetfair.com" />
//       <meta property="og:image" content="https://app.matkajantri.com/JantriImage/Logo.png" />
//       <meta name="google-site-verification" content="d6d81656210c6db7" />
//     </Helmet>
//     <HashRouter> {/* ✅ Wrap the app in HashRouter */}
//       <ContextProvider>
//         <App />
//       </ContextProvider>
//     </HashRouter>
//   </>
// );

// reportWebVitals();


import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ContextProvider } from './Context/Context';
// import { HashRouter } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <Helmet>
      <title>Matka Jantri | India’s Trusted Online Jantri Calculator & Record Maintainer for Matka Games</title>
      <meta
        name="description"
        content="Use Matka Jantri – India’s trusted online jantri calculator and matka record maintainer. APK for accurate and fast results. Easy to use on mobile and web."
      />
      <meta
        name="keywords"
        content="jantri, Matka Jantri, jantri calculator, matka games, jantri apk, record maintainer matka, satta matka jantri, jod calculator"
      />
      <meta name="author" content="Matka Jantri Team (Miraj Sport's)" />
      <meta property="og:title" content="Matka Jantri | Online Jantri Calculator for Matka Games" />
      <meta
        property="og:description"
        content="Free jantri calculator and record maintainer APK for matka games. Try Matka Jantri online – fast, accurate and easy to use."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://pushpabetfair.com" />
      <meta property="og:image" content="https://pushpabetfair.com/Logo.png" />
      <meta name="google-site-verification" content="d6d81656210c6db7" />
      {/* Favicon and icons */}
      <link rel="icon" href="/favicon.ico" type="image/x-icon" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
    </Helmet>

    <BrowserRouter>
      <ContextProvider>
        <App />
      </ContextProvider>
    </BrowserRouter>
  </HelmetProvider>
);

reportWebVitals();

